module.exports = __webpack_public_path__ + "img/antes_despues_287.4555b64f.png";